import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { toast } from 'react-toastify';
import {
  requestApi, RequestModel, ResponseModel,
  EndPointPaths, AssetConstants, printConsole,
  RouteConstants, SessionKeys, clientConfig,
  i18n, strings
} from '../../utils/CommonImports';

import { MobileDashboardResponse } from '../../appojo/responsemodel/MobileDashboardResponse';

import './HomeScreen.css';

const HomeScreen = (props: any) => {
  let navigate = useNavigate();
  const [stateValue, setStateValue] = useState({
    languageName: '',
    users: null,
    dashboardData: new MobileDashboardResponse(),
  });
  const [showLoader, setShowLoader] = useState(false);
  // const [cartQuantity, setCartQuantity] = useState(props.cartQuantity != null ? props.cartQuantity : 0);
  const [isConnected, setIsConnected] = useState(true);
  const [initialState, setInitialState] = useState(true);
  const [dummyData, setDummyData] = useState(true);

  useEffect(() => {
    getSessionValues()
      .then((user) => {
        console.log('moti check : ' + strings('developedby'))
        getAlldashboardData();
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }, 0)
      });

    return () => {

    }
  }, [props]);

  const getSessionValues = async () => {

    return true;
  }

  const getAlldashboardData = async () => {
    try {
      setShowLoader(true);
      const request = new RequestModel();
      request.userId = '809957651';
      request.reqObject = null;
      const responseResult = await requestApi(request, EndPointPaths.getalldashboarddata, isConnected);
      if (responseResult.status === 0) {
        const responsemodel: ResponseModel = responseResult.data;
        if (responsemodel.statusCode === 0) {
          const dataResp: MobileDashboardResponse = responsemodel.respObject;
          stateValue.dashboardData = dataResp;
          setStateValue(stateValue);
          setInitialState(false);
          saveStorage(dataResp, SessionKeys.dashboardData, "object");
          var fetchedTime = new Date();
          fetchedTime.setHours(fetchedTime.getHours(), fetchedTime.getMinutes() + 10, 0, 0);
          saveStorage(fetchedTime.getTime() + "", SessionKeys.fetchedTime, 'string');
        }
      } else if (responseResult.status === 1) {
        printConsole("API dash Error 1: " + responseResult.data)
      } else if (responseResult.status === 2) {
        printConsole("API dash Error 2: " + responseResult.data)
      } else {
        printConsole("API dash Error 3: " + responseResult.data)
      }
    } catch (err) {
      printConsole("Try Error dash: " + err);
    } finally {
      setShowLoader(false);
      setDummyData(!dummyData);
    }
  }
  const saveStorage = async (value: any, key: any, type: any) => {
    if (type === "object") {
      // console.log('JSON.stringify(value))
      sessionStorage.setItem(key, JSON.stringify(value));
    } else if (type === "remove") {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value)
    }
  }

  const settings = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: false,
    centerPadding: '100px',
    accessibility: false,
    arrows: true,
    dots: false,
    'responsive': [
      {
        'breakpoint': 600,
        'settings': {
          'slidesToShow': 1,
          'slidesToScroll': 1,
          centerPadding: '50px',
        }
      },
      {
        'breakpoint': 550,
        'settings': {
          'slidesToShow': 1,
          'slidesToScroll': 1,
          'centerMode': false,
          arrows: false,
          dots: true
        }
      },

    ],
  };
  const topListCloths = {
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    'responsive': [
      {
        'breakpoint': 1000,
        'settings': {
          'slidesToShow': 5,
          'slidesToScroll': 1,
          centerPadding: '100px',
        }
      }, {
        'breakpoint': 600,
        'settings': {
          'slidesToShow': 3,
          'slidesToScroll': 1,
          centerPadding: '50px',
        }
      },
      {
        'breakpoint': 550,
        'settings': {
          'slidesToShow': 2,
          'slidesToScroll': 1,
          'centerMode': true,
          speed: 100,
          arrows: false,
        }
      },
      {
        'breakpoint': 400,
        'settings': {
          'slidesToShow': 2.5,
          'slidesToScroll': 2,
          arrows: false,
        }
      },

    ],
  };
  const topListCloths2 = {
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    'responsive': [
      {
        'breakpoint': 1000,
        'settings': {
          'slidesToShow': 5,
          'slidesToScroll': 1,
          centerPadding: '100px',
        }
      }, {
        'breakpoint': 600,
        'settings': {
          'slidesToShow': 3,
          'slidesToScroll': 1,
          centerPadding: '50px',
        }
      },
      {
        'breakpoint': 550,
        'settings': {
          'slidesToShow': 3,
          'slidesToScroll': 1,
          'centerMode': false,
        }
      },
      {
        'breakpoint': 400,
        'settings': {
          'slidesToShow': 2.5,
          'slidesToScroll': 2,
          arrows: false,
        }
      },

    ],
  };
  // const history = useHistory();
  const buyNowClicked = (product: any) => {

    console.log(JSON.stringify(product));
    saveStorage(RouteConstants.DashBoard, SessionKeys.previousMenu, 'string');
    saveStorage(product, SessionKeys.productObj, 'object');

    console.log('jsx: ' + JSON.parse(sessionStorage.getItem(SessionKeys.productObj)))
    navigate("../productdetails");
  }
  return (
    < >
      <div>
        {initialState ? <div>
        </div> :
          <section className='mt-2' style={{ height: "auto", width: "100%", }}>
            <Slider {...settings} >
              {stateValue.dashboardData.sliderImages.map((clientObj, index) => {
                return (
                  <div key={index}>
                    <img alt="slider" className='sliderBanner' src={clientObj.imageUrl} />
                  </div>
                )
              })}
            </Slider>
          </section>
        }
      </div>
      {/* slider */}
      <div>
        {stateValue.dashboardData.dashboardContents == null ? null :
          stateValue.dashboardData?.dashboardContents?.map((prop, index) => {
            return (
              <div key={index}>
                <section className='mt-2 pt-4' style={{ height: "auto", width: "100%", backgroundColor: '#eee' }}>
                  <div className='container-fluid'>
                    <div >
                      <h4 className='pt-2 contentName' style={{ fontWeight: 'bolder' }}>{prop.dashboardContentName}</h4>
                    </div>
                    <Slider {...index == 0 ? topListCloths : topListCloths2} >
                      {prop.products.map((clientObj, index) => {
                        return (
                          <div key={index + 1} className='col-6 col-xl-2 col-lg-2 col-md-3 col-sm-4 mt-3 col-xs-4 responsiveColumn'>
                            <div className="eventsBox">
                              <div className="box">
                                <img alt="box" className='boxImage' src={clientObj.productThumbNailImage} />
                                <div className="content">
                                  <div className="wrap">
                                    <button className='butNowBtn' onClick={() => buyNowClicked(clientObj)}>Buy Now</button>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <h6 style={{ fontWeight: 'bolder' }} className='oneLineText'>{clientObj.title}</h6>
                                {/* <label className='oneLineText'>{clientObj.shortDescription}</label> */}
                                <p className='oneLineText'>{clientObj.shortDescription}</p>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </Slider>
                  </div>
                </section>
              </div>
            )
          })
        }

      </div>
      {/* slider */}
      <section className='mb-5'>
        <div className='container-fluid'>
          <div>
            <h4 className='text-center pt-5 pb-3'>HOW IT WORKS?</h4>
          </div>
          <div className='row'>
            <div className='col-sm-4 mt-1'>
              <div className='worksBox' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img alt="slider" style={{ height: '100px', width: '100px' }}
                    src='https://digilook.bizmobia.com/assets/images/home/digilook1.png' />
                  <h5 className='mt-4'>Choose your clothes</h5>
                  <h6>Browse our selection and choose what you want to receive </h6>
                </div>
              </div>
            </div>
            <div className='col-sm-4 mt-1'>
              <div className='worksBox' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img alt="slider" style={{ height: '100px', width: '100px' }} src='https://digilook.bizmobia.com/assets/images/home/digilook2.png' />
                  <h5 className='mt-4'>Wear at will</h5>
                  <h6>Enjoy your articles as much as you want </h6>
                </div>
              </div>
            </div>
            <div className='col-sm-4 mt-1'>
              <div className='worksBox' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img alt="slider" style={{ height: '100px', width: '100px' }} src='https://digilook.bizmobia.com/assets/images/home/digilook3.png' />
                  <h5 className='mt-4'>Return and Restart</h5>
                  <h6>Return us your selection while we prepare the next </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default HomeScreen;